import { Component, Input } from '@angular/core';

@Component({
  selector: 'cm-instance-custom-group',
  templateUrl: './instance-custom-group.component.html',
  styleUrls: ['./instance-custom-group.component.scss'],
})
export class InstanceCustomGroupComponent {
  @Input() name: string;
  showFields = true;

  get toggleClass() {
    return this.showFields ? 'fa-angle-up' : 'fa-angle-down';
  }

  toggleFields() {
    this.showFields = !this.showFields;
  }
}
